export const MEA_OPS_BASE_PATH = "/ops";

export const MEA_OPS_ROUTE_PATHS = Object.freeze({
  TRIAGE: "/triage",
  PORTFOLIO: "/portfolio",
});

export const MEA_OPS_ROUTES = Object.freeze({
  TRIAGE: `${MEA_OPS_BASE_PATH}${MEA_OPS_ROUTE_PATHS.TRIAGE}`,
  PORTFOLIO: `${MEA_OPS_BASE_PATH}${MEA_OPS_ROUTE_PATHS.PORTFOLIO}`,
});

export const LEGACY_MEA_OPS_ROUTES = Object.freeze({
  TRIAGE: "/user/triage",
  PORTFOLIO: "/user/portfolio",
});

export const normalizeMeaOpsRoute = (path) => {
  if (path === LEGACY_MEA_OPS_ROUTES.TRIAGE) {
    return MEA_OPS_ROUTES.TRIAGE;
  }
  if (path === LEGACY_MEA_OPS_ROUTES.PORTFOLIO) {
    return MEA_OPS_ROUTES.PORTFOLIO;
  }
  return path;
};
